import script from "./PageTips.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTips.vue?vue&type=script&setup=true&lang=js"

import "./PageTips.vue?vue&type=style&index=0&id=3bb3e54e&lang=less"

const __exports__ = script;

export default __exports__